import React, { useState } from 'react';

import { PartyBarData } from 'lib/PartyBar/partybar.types';
import SeatsChartDonut from './SeatsChartDonut';
import SeatsChartLegend from './SeatsChartLegend';

interface Props {
  lists: PartyBarData[];
}

const SeatsChart = ({ lists }: Props) => {
  const [hoveredListId, setHoveredListId] = useState<number>(null);

  const listsWithSeats = lists.filter(({ seatsClaimed }) => seatsClaimed);

  return (
    <>
      <SeatsChartDonut
        lists={listsWithSeats}
        hoveredListId={hoveredListId}
        setHoveredListId={setHoveredListId}
      />
      <SeatsChartLegend
        lists={listsWithSeats}
        hoveredListId={hoveredListId}
        setHoveredListId={setHoveredListId}
      />
    </>
  );
};

export default SeatsChart;
